// import { useCheckMedikreditStatusQuery } from '../../services/graphQLApi/queries';
import { useMediKreditPollStore } from '../../store/mediKreditPoll/mediKreditPollStore';
import MediKreditTooltip from './BankApiOfflineTooltip';

export default function MediKreditPoll() {
  const setAvailable = useMediKreditPollStore((state) => state.setAvailable);

  // const { data } = useCheckMedikreditStatusQuery(
  //   {},
  //   {
  //     pollingInterval: appConfig.mediKreditPollingInterval,
  //   },
  // );

  // useEffect(() => {
  //   setAvailable(data?.checkMedikreditStatus.isOnline ?? false);
  // }, [data]);

  setAvailable(true);

  return <MediKreditTooltip />;
}
